export var emptyPublisher = {
  observer: {},
  subscribe:
  /* istanbul ignore next */
  function subscribe() {
    return undefined;
  },
  unsubscribe:
  /* istanbul ignore next */
  function unsubscribe() {
    return undefined;
  }
};
export default function createObserverPublisher(Observer, options) {
  if (!Observer) {
    return emptyPublisher;
  }

  var subscribers = new WeakMap();
  var observer = new Observer(function (entries) {
    entries.forEach(function (entry) {
      var _ref = subscribers.get(entry.target) || {},
          callback = _ref.callback;

      if (!callback) {
        return;
      }

      callback(entry);
    });
  }, options);

  var unsubscribe = function unsubscribe(element) {
    if (!subscribers.get(element)) {
      return;
    }

    subscribers["delete"](element);

    if (!observer.unobserve) {
      observer.disconnect();
      return;
    }

    observer.unobserve(element);
  };

  var subscribe = function subscribe(target, callback) {
    var element = target.element || target;
    var targetOptions = target.options;
    var subscriber = subscribers.get(element);

    if (subscriber) {
      if (targetOptions === subscriber.options) {
        return;
      }

      unsubscribe(element);
    }

    subscribers.set(element, {
      callback: callback,
      options: targetOptions
    });
    observer.observe(element, targetOptions);
  };

  return {
    observer: observer,
    subscribe: subscribe,
    unsubscribe: unsubscribe
  };
}